module.exports = __webpack_public_path__ + "img/access3.15c46dae.png";